import { render, staticRenderFns } from "./fontscale.vue?vue&type=template&id=151593e9&scoped=true&lang=pug&"
import script from "./fontscale.vue?vue&type=script&lang=js&"
export * from "./fontscale.vue?vue&type=script&lang=js&"
import style0 from "./fontscale.vue?vue&type=style&index=0&id=151593e9&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151593e9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('151593e9', component.options)
    } else {
      api.reload('151593e9', component.options)
    }
    module.hot.accept("./fontscale.vue?vue&type=template&id=151593e9&scoped=true&lang=pug&", function () {
      api.rerender('151593e9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form_element/typography/fontscale.vue"
export default component.exports